// extracted by mini-css-extract-plugin
module.exports = {"info-tooltip":"InfoTooltip_info-tooltip__jCFuP","default":"InfoTooltip_default__1hH6m","right":"InfoTooltip_right___s_tN","left":"InfoTooltip_left__HgkxU"};